import React, { useId } from "react";
import { Tooltip as ReactTooltip } from "react-tooltip";

import classes from "./tooltip.module.css";
import { mergeClass } from "@/utils/helper";

function Tooltip({
  tooltipText,
  children,
  customTooltipContainer = "",
  place = "top", //'top' ,'top-start' ,'top-end' ,'right' ,'right-start' ,'right-end' ,'bottom' ,'bottom-start' ,'bottom-end' ,'left' ,'left-start' ,'left-end',
  ...rest
}) {
  const randomId = useId();
  return (
    <div>
      <div
        data-tooltip-id={`${randomId}`}
        data-tooltip-content={tooltipText}
      >
        {children}
      </div>
      <ReactTooltip
        id={`${randomId}`}
        className={mergeClass(
          classes?.tooltipContainer,
          customTooltipContainer
        )}
        delayShow={100}
        delayHide={-100}
        place={place}
        noArrow={true}
        {...rest}
      />
    </div>
  );
}

export default Tooltip;
